import { NavLink, useNavigate } from "react-router-dom";
import "../../assets/styles/sliderBar.css";

function StudentSidebar({ open, setOpen }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/");
  };

  return (
    <div className={open ? "student-sidebar active" : "student-sidebar"}>
      {/* MENU BUTTON */}
      
      <h2 className="logo">Shuttle Craft</h2>

      <ul onClick={() => setOpen(false)}>
        <li>
          <NavLink to="/student-dashboard">Dashboard</NavLink>
        </li>

        <li>
          <NavLink to="/student-profile">Profile</NavLink>
        </li>

        <li>
          <NavLink to="/student-attendance">Attendance</NavLink>
        </li>

        <li>
          <NavLink to="/student-payments">Payments</NavLink>
        </li>

        <li onClick={handleLogout}>Logout</li>
      </ul>
    </div>
  );
}

export default StudentSidebar;
